import Admin_page from './admin_page';


export default Admin_page;

export {
    Admin_page
}